// extracted by mini-css-extract-plugin
export default {"homepage":"c7y9L0FyvDbTNIDp8_Vb","section":"xyIteFY5GjEEDdiGHEkh","homepage_v2410":"PoOB_NSluKDxVDIEyqN3"};